<template>
  <v-container class="fill-height justify-center">
    <div>
      <v-row no-gutters class="flex-column align-center" data-testid="no-results-message-container">
        <v-icon class="mr-2 text-primary mb-3" size="x-large">mdi-laptop</v-icon>
        <strong class="no-results-message">{{ t('navigation.mobile.notReady.title') }}</strong>
        <span class="px-4 text-center pt-3">{{ t('navigation.mobile.notReady.subtitle') }}</span>
        <outline-button class="mt-4" to="/appointments">
          {{ t('navigation.mobile.notReady.goToAppointments') }}
        </outline-button>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { useI18n } from 'vue-i18n';

export default {
  setup() {
    const { t } = useI18n();
    return { t };
  }
};
</script>
